













import Vue from 'vue';
import CvHeader from '@/containers/cv-header/index.vue';
import CoverLetterHeader from '@/containers/cover-letter-header/index.vue';
import NotificationEmitter from '@/components/NotificationEmitter.vue';

// Use the module to get cv for share dialog
import * as CvSettingStore from '@/containers/cv-setting/store';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers(CvSettingStore.namespace);

export default Vue.extend({
  components: {
    NotificationEmitter,
    CvHeader,
    CoverLetterHeader,
  },
  computed: {
    ...mapGetters(['cv']),
    isCvRelatedPage(): boolean {
      return this.$route.path.startsWith('/app/cvs');
    },
    isCoverLetterRelatedPage(): boolean {
      return this.$route.path.startsWith('/app/cls');
    },
    coverLetterId(): string | null {
      return this.isCoverLetterRelatedPage ? this.$route.params.id : null;
    },
  },
  watch: {
    $route(to, _from) {
      this.createPageTitle(to);
      this.fetchCv(to.params.cv_id);
    },
  },
  mounted() {
    const to = this.$route;
    this.createPageTitle(to);
    this.fetchCv(to.params.cv_id);
  },
  methods: {
    createPageTitle(to) {
      if (to.meta.title) {
        document.title = to.meta.title + ' - プロフ（Proff） | スマート履歴書';
      } else {
        document.title = '編集 - プロフ（Proff） | スマート履歴書';
      }
    },
    fetchCv(cv_id: number | undefined) {
      if (cv_id) {
        this.$store.dispatch(CvSettingStore.GetCv.namespaced({ cv_id }));
      } else {
        this.$store.dispatch(CvSettingStore.ResetState.namespaced(null));
      }
    },
  },
});
